import React from 'react'
import { useSelector } from 'react-redux'

const AccessibilityAnnouncer = () => {
  const announcement = useSelector((state) => state.announcement.get('message'))

  return (
    <div className='sr-only' aria-live='polite' aria-atomic='true'>
      { announcement }
    </div>
  )
}

export default AccessibilityAnnouncer
